<template>
    <div>
      <Head title="Edit Post Price" />
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/post">Back</Link>
        <span class="text-indigo-400 font-medium">/Edit</span>
      </h1>
      <trashed-message v-if="content.deleted_at" class="mb-6" @restore="restore"> This content has been deleted. </trashed-message>
      <div class="url-container" style="display: flex; align-items: center; border-bottom: 1px solid #ccc; padding-bottom: 4px;">
                <a :href="content.cntnt_url" target="_blank" style="flex: 1; text-decoration: none; color: #007bff;">
                 Click here to view  
                </a>
                <!-- <button @click="copyToClipboard" style="background: none; border: none; cursor: pointer; margin-left: 8px;">
                  📋
                </button> -->
              </div>
      <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="update">
            <div class="flex space-x-6">
              <div v-html="embedHtml" ></div>
  
            <div class="flex flex-wrap  -mr-6 p-8">
    
         
            <div class="bg-blue-300 border border-gray-200 rounded-md p-4 pb-0 mb-2 shadow-sm w-full" >
                <h3 class="text-lg font-semibold text-gray-700 mb-4">Pricing Details <button
                type="button"
                @click="addMore"
                class="float-right focus:outline-none text-gray-900 bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:focus:ring-yellow-900"
                >
                Add Item +
                </button></h3>
            
                <div v-for="(row, index) in pricingDetails" :key="index" class="flex flex-wrap  -mr-6 ">
                    <text-input
                    v-model="row.itemcode"
                    :error="form.errors[`pricingDetails.${index}.itemcode`]"
                    class="pb-8 pr-6 w-full sm:w-1/4"
                    label="Item Code"
                    />
                    <text-input
                    v-model="row.market_price"
                    :error="form.errors[`pricingDetails.${index}.market_price`]"
                    class="pb-8 pr-6 w-full sm:w-1/4"
                    label="Market Price"
                    />
                
                    <text-input
                    v-model="row.deal_price"
                    :error="form.errors[`pricingDetails.${index}.deal_price`]"
                    class="pb-8 pr-6 w-full sm:w-1/4"
                    label="Deal Price"
                    />
                
                    <!-- Remove Button -->
                    <button
                    v-if="index > 0"
                    type="button"
                    @click="removeRow(index)"
                    class="text-red-500 bg-transparent hover:text-red-700 border border-red-500 hover:bg-red-100 focus:ring-4 focus:outline-none focus:ring-red-300 text-sm px-3 py-1 ml-0 mt-4 sm:ml-4 self-center rounded-md w-full sm:w-auto"
                    >
                    Remove
                    </button>
                </div>
    
            </div>
    
                <div class="pb-8 pr-6 w-full lg:w-1/2">
                <label class="form-label" >Deal Barcode:</label>
                <input
                type="radio"
                value="Barcode"
                v-model="form.deal" 
                class="pb-8 pr-6 w-full lg:w-1/2"
                />
                </div>
    
                <div class="pb-8 pr-6 w-full lg:w-1/2">
                <label class="form-label" >Deal Custom SQL:</label>
                <input
                type="radio"
                value="SQL"
                v-model="form.deal" 
                class="pb-8 pr-6 w-full lg:w-1/2"
                />
                <a 
                    href="https://plutokm.com/build_filterString_sales_table.php" 
                    title="Create a custom SQL" 
                    target="_blank"
                    class="text-blue-500 hover:text-blue-700 underline font-medium transition duration-200"
                >
                Open Query Builder
                </a>
                </div>
    
                <textarea-input v-if="form.deal === 'Barcode'" :rows="5" :cols="9"  v-model="form.deal_barcodes" placeholder="Ex:B0123,AB256" :error="form.errors.deal_barcodes" :type="radio" class="pb-8 pr-6 w-full "  />
                <textarea-input  v-if="form.deal === 'SQL'" :rows="5" :cols="9" v-model="form.deal_items_sql" :error="form.errors.deal_items_sql" :type="radio" class="pb-8 pr-6 w-full " placeholder="Custom SQL" />
    
               
                <!-- {{ this.content }} -->
    
            </div>

          </div>

          <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
            <!-- <button v-if="!creator.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Creator</button> -->
            <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Post</loading-button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/Layout'
  import TextInput from '@/Shared/TextInput'
  import TextareaInput from '../../Shared/TextareaInput.vue'
  import SelectInput from '@/Shared/SelectInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import TrashedMessage from '@/Shared/TrashedMessage'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  
  export default {
    components: {
      Head,
      Link,
      LoadingButton,
      SelectInput,
      TextInput,
      TrashedMessage,
      TextareaInput,
      Multiselect,
    },
    layout: Layout,
    props: {
        reelUrl: {
      type: String,
      required: true
    },
      content: Object,
      creators:Array,
      storeOptions: Array,
      stores:Array,
      anchors:Array,
      initialPricingDetails: {
        type: Array,
        default: () => [],
      },
    },
    remember: 'form',
    data() {
      return {
         embedHtml: '',
        pricingDetails: [
          {
            itemcode: "",
            market_price: "",
            deal_price: "",
          },
        ], 
        form: this.$inertia.form({
          // pltf_id: this.content.pltf_id,
          // crtr_id: this.content.selected_creators ?? [],
          // ers_loc_ids: this.content.ers_loc_ids ?? [],
          // cntnt_url: this.content.cntnt_url ?? '',
          // cntnt_is_inhouse: this.content.cntnt_is_inhouse ?? '',
          // cntnt_owner: this.content.cntnt_owner ?? 0,
          // cntnt_is_prod: this.content.cntnt_is_prod ?? '',
          // cntnt_type: this.content.cntnt_type ?? '',
          // cntnt_format: this.content.cntnt_format ?? '',
          // cntnt_has_offer: this.content.cntnt_has_offer ?? '',
          // cntnt_market_price: this.content.cntnt_market_price ?? '',
          // cntnt_platform_price: this.content.cntnt_platform_price ?? 0,
          // cntnt_deal_price: this.content.cntnt_deal_price ?? '',
          // cntnt_crtr_charges: this.content.cntnt_crtr_charges ?? 0,
          // cntnt_platform_charges: this.content.cntnt_platform_charges ?? 0,
          deal_barcodes: this.content.deal_barcodes ?? '',
          deal_items_sql: this.content.deal_items_sql ?? '',
          deal: (this.content.deal_barcodes ) ? 'Barcode' : 'SQL',
          // storeOptions: this.stores,
          // anchors:this.anchors,
          // promo_type:this.content.promo_type ?? '0',
          pricingDetails: []
        }),
        radio: '',
        value: "0",
  
      }
    },
    mounted() {
    // Set the Instagram blockquote HTML
        if (this.content.cntnt_url) {
            this.embedHtml = `
            <blockquote 
                class="instagram-media" 
                data-instgrm-permalink="${this.content.cntnt_url}" 
                data-instgrm-version="14"
                style="background:#FFF; border:0; margin:1px; padding:0; width:100%; max-width:540px;">
            </blockquote>
            `;
            // Load Instagram embed script
            this.loadInstagramScript();
        }
    },
    created() {
      // console.log(this.initialPricingDetails);
      if (this.initialPricingDetails && this.initialPricingDetails.length) {
        this.pricingDetails = [...this.initialPricingDetails];
      }
    },
    computed: {
      showOnlinePromoType() {
        // Check if any selected store has "ecom" in its name
        return this.form.ers_loc_ids.some((store) => store.name.toLowerCase().includes("ecom"));
      },
    },
    
    methods: {
      copyToClipboard() {
      const el = document.createElement('textarea');
      el.value = this.content.cntnt_url;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      // alert('URL copied!');
    },
    loadInstagramScript() {
      if (!window.instgrm) {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://www.instagram.com/embed.js');
        script.async = true;
        script.onload = () => {
          window.instgrm.Embeds.process();
        };
        document.body.appendChild(script);
      } else {
        window.instgrm.Embeds.process();
      }
    },
      addMore() {
        this.pricingDetails.push({
        itemcode: "",
        market_price: "",
        deal_price: "",
      });
        
      },
      removeRow(index) {
      // Remove the row at the specified index
        this.pricingDetails.splice(index, 1);
      },
      update() {
        this.form.pricingDetails = this.pricingDetails;
        console.log(this.form.pricingDetails);
         
        this.form.put(`/post/${this.content.cntnt_id}/buyerupdate`)
      },
      restore() {
        if (confirm('Are you sure you want to restore this contact?')) {
          this.$inertia.put(`/post/${this.content.cntnt_id}/restore`)
        }
      },
    },
  }
  </script>
  <style scoped>
  .bg-blue-300{
    background-color: rgb(147 197 253);
  }
  .disabled {
      cursor: not-allowed; /* Prevent pointer effect */
      opacity: 0.5; /* Optional: Visual feedback for disabled state */
      pointer-events: none; /* Ensure it is non-clickable */
  }
  .text-blue-500 {
    color: #3b82f6;
  }
  
  .text-blue-500:hover {
    color: #1d4ed8;
  }
  
  .bg-yellow-300{
    background-color: rgb(246, 253, 147);
  }
  </style>